import React, { useState, useEffect } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { setUser } from "../utils/auth"
import APIS from "../utils/APIS"
import queryString from "query-string"

const RegisterCandidat = () => {
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState()

  const [isValidRequest, setIsValidRequest] = useState(null)
  const [infos, setInfos] = useState({})
  useEffect(() => {
    const urlParams = queryString.parse(location.search)
    window.history.replaceState(null, null, window.location.pathname)
    if (urlParams.i && urlParams.email && urlParams.otp) {
      //on va vérifier que les infos sont correctes
      APIS.checkRegisterCandidat({email : urlParams.email, id : urlParams.i, otp: urlParams.otp}).then((result) => {
        if (result?.message === "checkRegisterCandidat") {
          setInfos({
            id : urlParams.i,
            email : urlParams.email,
            otp : urlParams.otp,
          })
          setIsValidRequest(true)
        } else {
          setIsValidRequest(false)
        }
      })
    } else {
      setIsValidRequest(false)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>Création compte | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          {isValidRequest === "final" &&
            <Box sx={{ mb: 3, textAlign:"center" }}>
              <Typography
                color="textBlack"
                variant="h2"
              >
                Validation compte
              </Typography>
              <Typography
                color="textPrimary"
                gutterBottom
                mt={2}
                variant="body2"
              >
                Un email contenant un lien pour créer votre mot de passe a été envoyé.
              </Typography>
              <Box sx={{ py: 2 }}>
                <RouterLink to="/login">
                  <Button
                    color="primary"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    endIcon={<ChevronRightIcon/>}
                  >
                    Se connecter
                  </Button>
                </RouterLink>
              </Box>
            </Box>
          }
          {isValidRequest === false &&
            <Box sx={{ mb: 3, textAlign:"center" }}>
              <Typography
                color="textBlack"
                variant="h2"
              >
                Création compte
              </Typography>
              <Typography
                color="textPrimary"
                gutterBottom
                variant="body2"
              >
                Les informations ne sont pas valides
              </Typography>
            </Box>
          }
          {isValidRequest === true &&
            <Formik
              initialValues={{
                firstName : '',
                name : '',
              }}
              validationSchema={Yup.object().shape({
                firstName: Yup.string().min(2, "Votre prénom est requis").max(255).required('Votre prénom est requis'),
                name: Yup.string().min(2, "Votre nom est requis").max(255).required('Votre nom est requis'),
              })}
              onSubmit={(values, { setSubmitting }) => {
                setAlertMessage("");
                const vals = { id : infos?.id, email: infos?.email, firstName: values.firstName, name: values.name }
                APIS.validRegisterCandidat(vals).then(result => {
                  if (result?.message === "validRegisterCandidat") {
                    APIS.askForNewPasswordEmail({email : infos?.email}).then(resultPassword => {
                      if (resultPassword?.message === "askForNewPasswordEmail") {
                        setIsValidRequest("final")
                      }
                    })
                  } else {
                    setAlertMessage("Erreur");
                    setSubmitting(false);
                  }
                })

              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                setFieldValue,
                handleSubmit,
                isSubmitting,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box sx={{ mb: 3, textAlign:"center" }}>
                    <Typography
                      color="textBlack"
                      variant="h2"
                    >
                      Avant de commencer
                    </Typography>
                    <Typography
                      color="textPrimary"
                      gutterBottom
                      variant="body2"
                    >
                      Nous avons besoin de quelques informations
                    </Typography>
                  </Box>

                  <Box sx={{display:"flex", gap:"15px"}}>
                    <TextField
                      error={Boolean(touched.firstName && errors.firstName)}
                      fullWidth
                      helperText={touched.firstName && errors.firstName}
                      label="Prénom"
                      margin="normal"
                      name="firstName"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="text"
                      value={values.firstName}
                      variant="outlined"
                    />
                    <TextField
                      error={Boolean(touched.name && errors.name)}
                      fullWidth
                      helperText={touched.name && errors.name}
                      label="Nom"
                      margin="normal"
                      name="name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="text"
                      value={values.name}
                      variant="outlined"
                    />
                  </Box>
                  <Box sx={{ py: 2 }}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      endIcon={<ChevronRightIcon/>}
                    >
                      Suivant
                    </Button>
                  </Box>
                  {alertMessage && alertMessage.length > 0 && (
                    <Box
                      sx={{
                        pb: 1,
                        pt: 2
                      }}
                    >
                      <Typography
                        align="center"
                        color="red"
                        variant="body1"
                      >
                        {alertMessage}
                      </Typography>
                    </Box>
                  )}
                </form>
              )}
            </Formik>
          }
        </Container>
      </Box>
    </>
  );
};

export default RegisterCandidat;
